// 2_components/carousel.js
// Homepage (#carousel) enhancements: builds a thumbnail strip that swaps the
// active slide, and adds mobile left/right scroll controls.

export function init() {
	if (!document.body.classList.contains("in-index")) return;

	carouselThumbnails();
	carouselSlideForMobile();
}

function carouselThumbnails() {
	const carousel = document.querySelector("#carousel");
	if (!carousel) return;

	const items = carousel.querySelectorAll(".item");
	if (!items || items.length === 0) return;

	const thumbNailsWrapper = document.createElement("div");
	thumbNailsWrapper.classList.add("carousel-thumbnails-wrapper");

	items.forEach((item, index) => {
		const thumbNail = item.querySelector(".item-thumbnail");
		if (thumbNail) {
			thumbNailsWrapper.appendChild(thumbNail);
			if (index === 0) {
				thumbNail.classList.add("active");
			}

			thumbNail.addEventListener("click", () => {
				if (thumbNail.classList.contains("active")) return;
				// remove active class from all thumbnails
				const allThumbnails = thumbNailsWrapper.querySelectorAll(".item-thumbnail");
				allThumbnails.forEach((thumb) => {
					thumb.classList.remove("active");
				});
				// add active class to clicked thumbnail
				thumbNail.classList.add("active");

				const allItems = carousel.querySelectorAll(".item");
				allItems.forEach((it) => {
					it.classList.remove("previous");

					if (it.classList.contains("active")) {
						it.classList.remove("active");
						it.classList.add("previous");
					}
				});
				item.classList.add("active");
			});
		}
	});
	carousel.appendChild(thumbNailsWrapper);
}

function carouselSlideForMobile() {
	const carousel = document.querySelector("#carousel");
	if (!carousel) return;

	const carouselInner = carousel.querySelector(".carousel-inner");
	if (!carouselInner) return;

	const carouselControlLeft = carousel.querySelector(".carousel-control.left");
	const carouselControlRight = carousel.querySelector(".carousel-control.right");
	if (!carouselControlLeft || !carouselControlRight) return;

	carouselControlLeft.classList.add("hidden");

	carouselControlLeft.addEventListener("click", () => {
		carouselInner.scrollBy({
			left: -carouselInner.clientWidth,
			behavior: "smooth",
		});
	});

	carouselControlRight.addEventListener("click", () => {
		carouselInner.scrollBy({
			left: carouselInner.clientWidth,
			behavior: "smooth",
		});
	});

	// On scroll: hide the left control at the start, hide the right control at the end.
	carouselInner.addEventListener("scroll", () => {
		if (carouselInner.scrollLeft === 0) {
			carouselControlLeft.classList.add("hidden");
		} else {
			carouselControlLeft.classList.remove("hidden");
		}
		if (carouselInner.scrollLeft + carouselInner.clientWidth + 1 >= carouselInner.scrollWidth) {
			carouselControlRight.classList.add("hidden");
		} else {
			carouselControlRight.classList.remove("hidden");
		}
	});
}
